import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const ProcessLogSummaryViewModule = new Module({
  id: 'PROCESS-LOG-SUMMARY:RESULT-TABLE',
  name: 'Process Log Summary',
  label: 'Process Log Summary',
  path: 'process-log-summary',
  Component: ComponentLoader(
    lazy(() => import('src/content/reports/ProcessLogSummary/View'))
  ),
  actions: {
    viewOrderSummary: {
      id: 'PROCESS-LOG-SUMMARY:VIEW:ORDER-SUMMARY',
      name: 'viewOrderSummary',
      label: 'View Order Summary'
    }
  }
});

const ProcessLogSummaryModules = [ProcessLogSummaryViewModule];

export default new ModuleBundle('ProcessLogSummary', ProcessLogSummaryModules);
